import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login';
import { AuthGuard } from './_guards';
import { ForgotPasswordComponent } from './forgotpassword/forgotpassword.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { Configuration } from './configuration/configurations';
import {ResetpasswordComponent} from './resetpassword/resetpassword.component';
import {AllocatecallhistoryComponent} from './allocatecallhistory/allocatecallhistory.component';
import {AllocatehistoryComponent} from './allocatehistory/allocatehistory.component';
import {UnallocatecalllogComponent} from './unallocatecalllog/unallocatecalllog.component';
import {AddTaskTimeComponent} from './addtasktime/addtasktime.component';
import {ContactusComponent} from './contactus/contactus.component';
import {PrivacypolicyComponent} from './privacypolicy/privacypolicy.component';
import {TermsconditionComponent} from './termscondition/termscondition.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import {UnauthenticationuserComponent} from './unauthenticationuser/unauthenticationuser.component';

const routes: Routes = [
  { path: '', component: LoginComponent },
  { path: 'login', component: LoginComponent },
  { path: 'forgotpassword', component: ForgotPasswordComponent },
  { path: 'dashboard', component: DashboardComponent,canActivate: [AuthGuard]},
  {path:'resetpassword',component:ResetpasswordComponent},
  {path:'allocatecall',component:AllocatecallhistoryComponent, canActivate: [AuthGuard]},
  {path:'allocatehistory',component:AllocatehistoryComponent, canActivate: [AuthGuard]},
  {path:'addtasktime',component:AddTaskTimeComponent, canActivate: [AuthGuard]},
  {path:'unallocatecall',component:UnallocatecalllogComponent, canActivate: [AuthGuard]},
  {path:'contactus',component:ContactusComponent, canActivate: [AuthGuard]},
  {path:'unauthenticationuser',component:UnauthenticationuserComponent, canActivate: [AuthGuard]},
  {path:'privacypolicy',component:PrivacypolicyComponent},
  {path:'termscondition',component:TermsconditionComponent},
  {path:'sidebar',component:SidebarComponent},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  //imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule {

  constructor(private _configurations: Configuration) { }
}


